<template>
  <v-data-table
    :search="search"
    :headers="tableHeaders"
    :items="items"
    :items-per-page="15"
    class="main-table"
  >
    <template #[`item.amount`]="{ item }">
      <span>{{ formatNumber(item.amount, '$') }}</span>
    </template>
    <template #[`item.number`]="{ item }">
      {{ item.number }}
      <special-order-type-icon :order="item.auart" />
    </template>
    <template #[`item.deliveryDate`]="{ item }">
      {{ formatISODate(item.deliveryDate) }}
    </template>
    <template #[`item.actions`]="{ item }">
      <v-icon color="#218838" @click="$emit('onPDFClick', item.actions, 2)">
        mdi-file-xml-box
      </v-icon>
      <v-icon
        color="red darken-2"
        @click="$emit('onPDFClick', item.actions, 1)"
      >
        mdi-file-pdf-box
      </v-icon>
      <a v-if="item.accuse != ''" :href="item.accuse" target="_blank">
        <v-icon dense color="green"> mdi-file-download </v-icon>
      </a>
      <v-icon
        v-if="item.accuse == '' && item.accuseDocument == 1"
        dense
        color="green"
        @click="$emit('onAccuseClick', item.actions)"
      >
        mdi-file-download
      </v-icon>
      <v-progress-circular
        v-if="loading.load && loading.invoice == item.actions"
        indeterminate
        color="green"
        size="15"
        width="2"
        style="transform: translateY(-3px)"
      />
    </template>
    <template #[`item.payComplement`]="{ item }">
      <a
        v-if="item.payComplement != ''"
        href="#"
        @click="$emit('onPDFClick', item.payComplement, 2)"
      >
        <v-icon dense size="24" color="#218838"> mdi-file-xml-box </v-icon>
      </a>
      <a
        v-if="item.payComplement != ''"
        @click="$emit('onPDFClick', item.payComplement, 1)"
      >
        <v-icon dense size="24" color="red"> mdi-file-pdf-box </v-icon>
      </a>
    </template>
  </v-data-table>
</template>
<script>
  import moment from 'moment';
  import SpecialOrderTypeIcon from '@/components/SpecialOrderTypeIcon.vue';
  import dateFormats from '@/core/constants/DateFormats';
  import numbersFormats from '@/mixins/numbersFormats';

  const sortByDate = (a, b) => {
    if (!a) return -1;
    if (!b) return 1;
    return moment(a, [dateFormats.DISPLAY_DATE, dateFormats.ISO_DATE]).diff(
      moment(b, [dateFormats.DISPLAY_DATE, dateFormats.ISO_DATE])
    );
  };

  const headerHistory = [
    { text: '# Documento', value: 'number' },
    { text: 'Tipo Documento', align: 'start', sortable: false, value: 'type' },
    { text: 'Orden de Compra', value: 'orderName' },
    { text: 'Fecha de Documento', value: 'date', sort: sortByDate },
    { text: 'Fecha de Entrega', value: 'deliveryDate', sort: sortByDate },
    { text: 'Fecha de Vencimiento', value: 'dateOverdue', sort: sortByDate },
    { text: 'Importe', value: 'amount' },
    {
      text: 'XML/PDF/ACUSE',
      value: 'actions',
      sortable: false,
      width: '100px',
    },
    {
      text: 'Complemento de Pago',
      sortable: false,
      value: 'payComplement',
      width: '80px',
    },
  ];

  export default {
    name: 'AccountStatusTable',
    components: {
      SpecialOrderTypeIcon,
    },
    mixins: [numbersFormats],
    props: {
      items: {
        type: Array,
        required: true,
      },
      search: {
        type: String,
        default: null,
      },
      loading: {
        type: Object,
        required: true,
      },

      fullTable: Boolean,
      variant: Boolean,
    },
    data() {
      return {
        tableHeaders: headerHistory,
      };
    },
    methods: {
      formatISODate(date) {
        if (!date) return '';
        return moment(date, [
          dateFormats.ISO_DATE,
          dateFormats.DISPLAY_DATE,
        ]).format(dateFormats.DISPLAY_DATE);
      },
    },
  };
</script>
<style scoped src="@/assets/css/table.css"></style>
